import User from "../services/user"
import Axios from "axios"
import * as Auth from "./auth"
import * as MsgBox from "./msgBox"
import * as Html from "../utils/html"

function pathAuth(config) {
    let token = Auth.getAuth();
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
}

function getData(response) {
    return response.status === 204 ? void(0) : response.data;
}

function handleResponseError(error) {
    if (error && error.response && error.response.status === 401) {
        User.setUser(null);
    } else {
        let msg = (error && error.isAxiosError && error.response)
            ? `${error.response.status}: ${error.response.data || error.response.statusText}`
            : ((error && error.toString) ? error.toString() : JSON.stringify(error));
        MsgBox.alert(null, Html.vueFormat(msg), {title: "网络通讯错误"});
    }
    return Promise.reject(error);
}

function injectErrorHandler(handler) {
    if (handler) {
        let newAjax = Axios.create();
        newAjax.interceptors.request.use(pathAuth, Promise.reject);
        newAjax.interceptors.response.use(getData, error => handler(error).catch(handleResponseError));
        return newAjax;
    } else {
        return ajax;
    }
}

const ajax = Axios.create();
ajax.interceptors.request.use(pathAuth, Promise.reject);
ajax.interceptors.response.use(getData, handleResponseError);
ajax.onError = injectErrorHandler;
export default ajax;
